$(function(){

    var _animIndex={},_animStorage={};


    $.fn.soccerGame=function(options,timeHandler,cursorArr){
        var th=$(this);
        var settings=th.data("soccerGame");
        var animIndex;

        function removeAnim(){
            delete _animIndex[animIndex];
            delete _animStorage[animIndex];
            th.data("soccerGame",false);
        }
        function drawScene(){

            if(typeof _animStorage[animIndex]!=="undefined"){

                timeHandler.set(animIndexArr.handler,function(){
//                    var tt=new Date().getTime();
                    _animStorage[animIndex].obj_anim.draw(ctx);
//                   $.qLog(((new Date().getTime())-tt)+" ");
                },settings.period,function(){
                    removeAnim();
                    _mySound.stopSound("soccer_crowd");
                });

            }
            return true;
        }
        var methods={
            start:function(){
                _animStorage[animIndex].obj_anim.start();
                _mySound.playSound("soccer_crowd");
                _mySound.playSound("soccer_whistle_start");
            },
            stop:function(){
                timeHandler.clear(_animIndex[animIndex].handler);
                _mySound.playSound("soccer_whistle_end");
            },
            kick:function(){
                _animStorage[animIndex].obj_anim.kick();
            },
            takeAnimIndex:function(){
                return animIndex;
            },
            takeEventArr:function(){
                return _animStorage[animIndex].obj_anim.takeEventArr();
            },
            addText:function(text,pos,stroke_color){
                _animStorage[animIndex].obj_anim.addText(text,pos,stroke_color);
            },
            takeConf:function(){
                return _animStorage[animIndex].obj_anim.takeConf();
            }
        };
        function girlObj(posEnd,hard,hard_max){
            this.speed_move_const=5;
            this.speed_defense_const=15;
            this.hard=hard;
            this.hard_max=hard_max;
            this.images={};
            this.girl_size=[900,522];
            this.imagesConf={
                girl_move_left:{clips:9,width:900,height:522,path:_IMG_SERV+"/gfx/place/soccergame/girl/move/left.png"},
                girl_move_right:{clips:9,width:900,height:522,path:_IMG_SERV+"/gfx/place/soccergame/girl/move/right.png"},
                girl_move_wait:{clips:13,width:900,height:522,path:_IMG_SERV+"/gfx/place/soccergame/girl/move/wait.png?2"},
                girl_defend_0_7:{clips:7,width:900,height:522,path:_IMG_SERV+"/gfx/place/soccergame/girl/defend/down.png"},
                girl_defend_0_7_back:{clips:7,width:900,height:522,path:_IMG_SERV+"/gfx/place/soccergame/girl/defend/down_back.png"},
                "girl_defend_-2_1":{clips:8,width:900,height:522,path:_IMG_SERV+"/gfx/place/soccergame/girl/defend/left_up.png"},
                "girl_defend_-2_1_fall":{clips:11,width:900,height:522,path:_IMG_SERV+"/gfx/place/soccergame/girl/defend/left_up_fall.png"},
                "girl_defend_-2_1_up":{clips:16,width:900,height:522,path:_IMG_SERV+"/gfx/place/soccergame/girl/defend/left_up_up.png"},
                "girl_defend_2_1":{clips:8,width:900,height:522,path:_IMG_SERV+"/gfx/place/soccergame/girl/defend/right_up.png"},
                "girl_defend_2_1_fall":{clips:11,width:900,height:522,path:_IMG_SERV+"/gfx/place/soccergame/girl/defend/right_up_fall.png"},
                "girl_defend_2_1_up":{clips:16,width:900,height:522,path:_IMG_SERV+"/gfx/place/soccergame/girl/defend/right_up_up.png"},

                "girl_defend_0_1":{clips:10,width:900,height:522,path:_IMG_SERV+"/gfx/place/soccergame/girl/defend/jump_up.png"},
                "girl_defend_-1_7":{clips:14,width:900,height:522,path:_IMG_SERV+"/gfx/place/soccergame/girl/defend/left_down.png"},
                "girl_defend_-1_7_back":{clips:18,width:900,height:522,path:_IMG_SERV+"/gfx/place/soccergame/girl/defend/left_down_back.png"},
                "girl_defend_1_7":{clips:14,width:900,height:522,path:_IMG_SERV+"/gfx/place/soccergame/girl/defend/right_down.png"},
                "girl_defend_1_7_back":{clips:18,width:900,height:522,path:_IMG_SERV+"/gfx/place/soccergame/girl/defend/right_down_back.png"},
                girl_defend_0_3:{clips:8,width:900,height:522,path:_IMG_SERV+"/gfx/place/soccergame/girl/defend/middle_up.png?2"},
                girl_defend_0_4:{clips:10,width:900,height:522,path:_IMG_SERV+"/gfx/place/soccergame/girl/defend/jump.png"},
                girl_defend_0_4_back:{clips:9,width:900,height:522,path:_IMG_SERV+"/gfx/place/soccergame/girl/defend/jump_back.png"},
                "girl_defend_-1_4":{clips:8,width:900,height:522,path:_IMG_SERV+"/gfx/place/soccergame/girl/defend/middle_left.png"},
                "girl_defend_1_4":{clips:8,width:900,height:522,path:_IMG_SERV+"/gfx/place/soccergame/girl/defend/middle_right.png"},

                "girl_defend_-1_3":{clips:8,width:900,height:522,path:_IMG_SERV+"/gfx/place/soccergame/girl/defend/middle_left_up.png"},
                "girl_defend_1_3":{clips:8,width:900,height:522,path:_IMG_SERV+"/gfx/place/soccergame/girl/defend/middle_right_up.png"},


                "girl_defend_-2_5":{clips:14,width:900,height:522,path:_IMG_SERV+"/gfx/place/soccergame/girl/defend/left_down_hand.png"},
                "girl_defend_-2_5_back":{clips:18,width:900,height:522,path:_IMG_SERV+"/gfx/place/soccergame/girl/defend/left_down_hand_back.png"},
                "girl_defend_2_5":{clips:14,width:900,height:522,path:_IMG_SERV+"/gfx/place/soccergame/girl/defend/right_down_hand.png"},
                "girl_defend_2_5_back":{clips:18,width:900,height:522,path:_IMG_SERV+"/gfx/place/soccergame/girl/defend/right_down_hand_back.png"}
            };
            this.defend_conf={
                x:{"-2":{range:[-2000,-200]}, "-1":{range:[-200,-75]},"0":{range:[-75,75]},"1":{range:[75,200]},"2":{range:[200,2000]}},

            };
            this.defend_wait_conf={
                "1":[0,3],
                "5":[4,6],
                "6":[5,8],
                "9":[7,11]
            };

            this.defend_conf_one={
                "0_1":{img:"girl_defend_0_1",pos_x_arr:[399,506],move:"during",two_side:1},
                "0_2":{img:"girl_defend_0_1",pos_x_arr:[399,506],move:"during",two_side:1},
                "0_3":{img:"girl_defend_0_3",pos_x_arr:[375,519],move:"during",two_side:1},
                "0_4":{img:"girl_defend_0_4",pos_x_arr:[399,506],move:"during",two_side:0,img_next_arr:["girl_defend_0_4_back"]},
                "0_5":{img:"girl_defend_0_4",pos_x_arr:[399,506],move:"during",two_side:0,img_next_arr:["girl_defend_0_4_back"]},
                "-1_3":{img:"girl_defend_-1_3",pos_x_arr:[333,372],move:"during",two_side:1},
                "1_3":{img:"girl_defend_1_3",pos_x_arr:[900-372,900-333],move:"during",two_side:1},
                "-1_1":{img:"girl_defend_0_1",pos_x_arr:[399,506],move:"during",two_side:1},
                "-1_2":{img:"girl_defend_0_1",pos_x_arr:[399,506],move:"during",two_side:1},
                "1_2":{img:"girl_defend_0_1",pos_x_arr:[399,506],move:"during",two_side:1},
                "1_1":{img:"girl_defend_0_1",pos_x_arr:[399,506],move:"during",two_side:1},
                "0_7":{img:"girl_defend_0_7",pos_x_arr:[255,644],move:"during",two_side:0,img_next_arr:["girl_defend_0_7_back"]},
                "0_6":{img:"girl_defend_0_7",pos_x_arr:[313,527],move:"during",two_side:0,img_next_arr:["girl_defend_0_7_back"]},


                "-1_4":{img:"girl_defend_-1_4",pos_x_arr:[277,400],move:"during",two_side:1},
                "1_4":{img:"girl_defend_1_4",pos_x_arr:[900-400,900-277],move:"during",two_side:1},




                "-1_7":{img:"girl_defend_-1_7",pos_x_arr:[140,518],move:"during",two_side:0,img_next_arr:["girl_defend_-1_7_back"]},
                "-2_7":{img:"girl_defend_-1_7",wait:9,pos_x_arr:[140,518],move:"during",two_side:0,img_next_arr:["girl_defend_-1_7_back"]},
                "-1_6":{img:"girl_defend_-1_7",pos_x_arr:[190,390],move:"during",two_side:0,img_next_arr:["girl_defend_-1_7_back"]},
                "-2_6":{img:"girl_defend_-1_7",wait:9,pos_x_arr:[190,390],move:"during",two_side:0,img_next_arr:["girl_defend_-1_7_back"]},

                "1_7":{img:"girl_defend_1_7",pos_x_arr:[900-518,900-140],move:"during",two_side:0,img_next_arr:["girl_defend_1_7_back"]},
                "2_7":{img:"girl_defend_1_7",wait:9,pos_x_arr:[900-518,900-140],move:"during",two_side:0,img_next_arr:["girl_defend_1_7_back"]},
                "1_6":{img:"girl_defend_1_7",pos_x_arr:[900-390,900-190],move:"during",two_side:0,img_next_arr:["girl_defend_1_7_back"]},
                "2_6":{img:"girl_defend_1_7",wait:9,pos_x_arr:[560,697],move:"during",two_side:0,img_next_arr:["girl_defend_1_7_back"]},


                "-2_1":{img:"girl_defend_-2_1",wait:6,pos_x:315,move:"after",img_next_arr:["girl_defend_-2_1_fall","girl_defend_-2_1_up"],two_side:0},
                "-2_2":{img:"girl_defend_-2_1",wait:6,pos_x:217,move:"after",img_next_arr:["girl_defend_-2_1_fall","girl_defend_-2_1_up"],two_side:0},
                "-2_3":{img:"girl_defend_-2_1",wait:1,pos_x:255,move:"after",img_next_arr:["girl_defend_-2_1_fall","girl_defend_-2_1_up"],two_side:0},
                "-2_4":{img:"girl_defend_-2_1",wait:1,pos_x:290,move:"after",img_next_arr:["girl_defend_-2_1_fall","girl_defend_-2_1_up"],two_side:0},

                "2_1":{img:"girl_defend_2_1",wait:6,pos_x:588,move:"after",img_next_arr:["girl_defend_2_1_fall","girl_defend_2_1_up"],two_side:0},
                "2_2":{img:"girl_defend_2_1",wait:6,pos_x:690,move:"after",img_next_arr:["girl_defend_2_1_fall","girl_defend_2_1_up"],two_side:0},
                "2_3":{img:"girl_defend_2_1",wait:1,pos_x:650,move:"after",img_next_arr:["girl_defend_2_1_fall","girl_defend_2_1_up"],two_side:0},
                "2_4":{img:"girl_defend_2_1",wait:1,pos_x:600,move:"after",img_next_arr:["girl_defend_2_1_fall","girl_defend_2_1_up"],two_side:0},

                "-1_5":{img:"girl_defend_-2_5",pos_x_arr:[218,350],move:"during",two_side:0,img_next_arr:["girl_defend_-2_5_back"]},
                "1_5":{img:"girl_defend_2_5",pos_x_arr:[900-350,900-218],move:"during",two_side:0,img_next_arr:["girl_defend_2_5_back"]},

                "-2_5":{img:"girl_defend_-2_5",wait:5,pos_x_arr:[218,350],move:"during",two_side:0,img_next_arr:["girl_defend_-2_5_back"]},
                "2_5":{img:"girl_defend_2_5",wait:5,pos_x_arr:[900-350,900-218],move:"during",two_side:0,img_next_arr:["girl_defend_2_5_back"]},
//                "2_4":{img:"girl_defend_2_5",pos_x_arr:[900-350,900-218],move:"during",two_side:0,img_next_arr:["girl_defend_2_5_back"]},
                //      "-1_1":{img:"girl_defend_-2_1",pos_x:217,move:"after",img_next_arr:["girl_defend_-2_1_fall","girl_defend_-2_1_up"],two_side:0},
//                "-1_2":{img:"girl_defend_-2_1",pos_x:217,move:"after",img_next_arr:["girl_defend_-2_1_fall","girl_defend_-2_1_up"],two_side:0}
            };
            this.gate=new gateObj();
            var gate_size=this.gate.takeTreshold([0,0]);
            this.gate_bottom=gate_size[1][1];
            this.decision="";//move,jump,wait

            this.decision_next_arr=[];
            this.decision_next_wait=0;

            this.decision_val="";
            this.pos=[0,0];
            this.pos_start=[];
            this.pos_end=posEnd;
            this.pos_last_end=[];
            this.step=0;
            this.step_anim=0;
            this.step_anim_type="";
            this.step_max=10;
            this.girl_height_fix=55;


            this.ball_size;
        }
        girlObj.prototype={
            init:function(ball_size){
                this.prepareImages();
                this.pos=[
                    640,
                    this.gate_bottom-Math.round(this.imagesConf["girl_move_wait"].height/2)
                ];
                this.pos_last_end=copyArray(this.pos);
                this.pos_start=copyArray(this.pos);
                this.setWait();
                this.ball_size=ball_size;

                this.testIsAll();
                this.setHerSkills();

            },
            setHerSkills:function(){
                var i,bum,wait_arr,wait;
                for(i in this.defend_conf_one){
                    bum=this.defend_conf_one[i];
                    if(typeof bum.wait!="undefined"){
                        wait_arr=this.defend_wait_conf[bum.wait];
                        wait=wait_arr[0]+(wait_arr[1]-wait_arr[0])*(1-this.hard/this.hard_max);
                        wait=Math.round(wait);
                        this.defend_conf_one[i].wait=wait;
//                        $.qLog( " w"+ wait+"w ");
                    }
                }
            },
            testIsAll:function(){
                var i,k;
                for(i=-2;i<=2;i++){
                    for(k=1;k<=7;k++){
                        if(typeof this.defend_conf_one[i+"_"+k]=="undefined"){
                            $.qLog(i+"_"+k+"<br>");
                        }
                    }
                }
            },
            prepareImages:function(){
                var key,bum;
                for(key in this.imagesConf){
                    bum=this.imagesConf[key];
                    this.images[key]=new Image();
                    this.images[key].src=bum.path;
                }
            },
            isBallHitGirl:function(ball_pos,ball_radius){
                if(typeof _soccerGameMap[this.decision_val]=="undefined"){
                    return false;
                }
//                var tt=new Date().getTime();
                var girl_pos=copyArray(this.pos);
                var step_anim=this.takeStepAnim();
//                step_anim=0;
                var conf=this.imagesConf[this.decision_val],
                    map=copyArray(_soccerGameMap[this.decision_val][step_anim]);
//                map=_soccerGameMap[this.decision_val][step_anim];
                //optimalization: adjust ball position to img

                var girl_pos_corner=[girl_pos[0]-conf.width/2,girl_pos[1]-conf.height/2];
                var vec_move=minusVector(ball_pos,girl_pos_corner);
                vec_move[0]+=step_anim*conf.width;
                vec_move[1]-=this.girl_height_fix;
                ball_pos[0]=vec_move[0];
                ball_pos[1]=vec_move[1];


                var ball_treshold=[
                    [ball_pos[0]-ball_radius,ball_pos[0]+ball_radius],
                    [ball_pos[1]-ball_radius,ball_pos[1]+ball_radius]
                ];

//                console.log(ball_pos);
//                var map=[0,0,100,100];
                var dist=30;
                var i,k,pos=[],pos_next=[],pos_arr,add_points,len=map.length/2;
                var debug=0;
                for(i=0;i<len;i++){
                    pos_arr=[];
                    pos[0]=map[2*i];
                    pos[1]=map[2*i+1];
                    pos_arr.push(pos);
                    if(typeof map[2*i+2]!="undefined"){
                        pos_next[0]=map[2*i+2];
                        pos_next[1]=map[2*i+3];
                        add_points=Math.max(
                            Math.round(Math.floor(pos_next[0]-pos[0])/dist),
                            Math.round(Math.floor(pos_next[1]-pos[1])/dist)
                        );
                        if(add_points>=2){
                            for(k=1;k<add_points;k++){
                                pos_arr.push([
                                    Math.round(pos[0]+(pos_next[0]-pos[0])*k/add_points),
                                    Math.round(pos[1]+(pos_next[1]-pos[1])*k/add_points),
                                ]);
                            }
                        }
                    }
                    for(k in pos_arr){
                        debug++;
                        pos=pos_arr[k];

                        if(pos[0]>ball_treshold[0][0] && pos[0]<ball_treshold[0][1] &&
                            pos[1]>ball_treshold[1][0] && pos[1]<ball_treshold[1][1]
                        ){
                            if(lengthVector(minusVector(pos,ball_pos))<ball_radius){
                                return true;
                            }

                        }
                    }
                }
                return false;

            },
            takeStepAnim:function(){
                var conf=this.imagesConf[this.decision_val];
                var step_anim;
                if(this.step_anim_type==""){
                    step_anim=this.step_anim%conf.clips;
                }
                else if(this.step_anim_type=="back"){
                    step_anim=(conf.clips-1)-this.step_anim%conf.clips;
                }
                else if(this.step_anim_type=="min"){
                    step_anim=Math.min(this.step_anim,conf.clips-1);
                }
                return step_anim;
            },

            draw:function(ctx){

                var conf=this.imagesConf[this.decision_val];


                //step_anim_type min, back

                var step_anim=this.takeStepAnim();

                if(this.decision=="defend"){
//                    $.qLog(this.step+"_"+this.step_max+" #### "+step_anim+" _____ "+this.step_anim_type+"<br>");
                }

                drawImageCropCenter(
                    ctx,this.images[this.decision_val],
                    this.pos[0],this.pos[1]+this.girl_height_fix,
                    (step_anim)*conf.width,0,
                    conf.width,conf.height
                );


            },
            move:function(){
                if(this.decision=="move"){

                    if(this.decision_next_arr.length==0){
                        if(this.pos_end[0]!=this.pos_last_end[0]){
                            this.setMove();
                        }
                        if(this.step>=this.step_max){
                            if(this.decision_val!="girl_move_wait"){
                                this.setWait();
                            }
                        }
                    }
                    else{
                        if(this.decision_next_wait<=0){
                            //use decision arr;
                            this.useDecisionArr();
                        }
                    }
                }
                if(this.decision=="defend"){
                    if(this.step>=this.step_max){
                        if(!this.useDecisionArr()){
                            this.setWait();
                        }
                    }
                }
                this.step++;
                this.decision_next_wait--;
                this.step_anim++;
                var x_move=this.pos_last_end[0]-this.pos_start[0];
                var step=Math.min(this.step,this.step_max);
                var pos=copyArray(this.pos);
                pos[0]=this.pos_start[0]+Math.round(x_move*step/this.step_max);
                this.pos[0]=pos[0];
            },
            setMove:function(){
                var val="";

                if(this.pos_end[0]>this.pos[0]){
                    val="girl_move_right";
                }
                else{
                    val="girl_move_left";
                }
                var clips_fast=this.imagesConf[val].clips;

                var pos_last_new=copyArray(this.pos_end);
                var qtreshold=this.gate.takeTreshold([0,0]);
                pos_last_new[0]=Math.max(pos_last_new[0],qtreshold[0][0]);
                pos_last_new[0]=Math.min(pos_last_new[0],qtreshold[0][1]);

                var distance=pos_last_new[0]-this.pos[0];
                var step_max=Math.abs(Math.ceil(distance/this.speed_move_const));
                if(step_max>=clips_fast){
                    this.pos_last_end=pos_last_new;
                    this.pos_start=copyArray(this.pos);

                    step_max=Math.ceil(step_max/clips_fast)*clips_fast;
                    this.step_max=step_max;
                    this.step=0;
                    this.step_anim_type="";
                    this.pos[1]=this.gate_bottom-Math.round(this.imagesConf[this.decision_val].height/2);
                    if(this.decision!="move" || this.decision_val!=val){
                        this.decision_val=val;
                        this.decision="move";
                        this.step_anim=-1;
                    }

                }
            },
            setWait:function(step_max){
                if(!step_max){
                    step_max=1;
                }
                this.decision="move";
                this.step=0;
                this.step_max=step_max;
                if(this.decision_val!="girl_move_wait"){
                    this.decision_val="girl_move_wait";
                    this.step_anim=-1;
                    this.step_anim_type="";
                }

//                this.pos=[
//                    640,
//                    this.gate_bottom-Math.round(this.imagesConf["girl_move_wait"].height/2)
//                ];


                this.pos[1]=this.gate_bottom-Math.round(this.imagesConf[this.decision_val].height/2);
                this.pos_last_end=copyArray(this.pos);
                this.pos_start=copyArray(this.pos);
            },
            findFieldId:function(pos){
                var x_id=0,y_id=0;
                var x_distance=pos[0]-this.pos[0];
                var i,bum;
                for(i in this.defend_conf.x){
                    bum=this.defend_conf.x[i].range;
                    if(x_id==0 && x_distance>=bum[0] && x_distance<=bum[1]){
                        x_id=i;
                    }
                }
                var gate_size=this.gate.takeTreshold([0,0]);
                var y=pos[1]-gate_size[1][0];
                var i;
                var real_bottom=20;
                var height=gate_size[1][1]-gate_size[1][0]-this.ball_size/2-real_bottom;
                var ball_part=Math.ceil((height-real_bottom)/11);

                for(i=1;i<=7;i++){
//                    $.qLog(i+": "+(ball_part*(2*i-3))+"___"+(ball_part*2*i-1)+"<br>");
                    if(y>=ball_part*(2*i-3) && y<ball_part*2*i-1){
                        y_id=i;
//                        $.qLog(y_id+": "+(ball_part*(2*i-3))+"___"+(ball_part*2*i-1)+"<br>");
                    }
                }
                if(y<0){
                    y_id=0;
//                    $.qLog("jj");
                }
                if(y>=height-real_bottom){
                    y_id=7;
                }

//                $.qLog("  |"+y+"=>"+x_id+"_"+y_id+"| ");
                return [x_id,y_id];
            },
            countDefendX:function(pos,conf){
                var x_move=pos[0]-this.pos[0]+Math.round(this.girl_size[0]/2);
                if(typeof conf.pos_x_arr!="undefined"){
                    if(x_move>=conf.pos_x_arr[0] && x_move<=conf.pos_x_arr[1]){
                        x_move=0;
                    }
                    else if(x_move<conf.pos_x_arr[0]){
                        x_move-=conf.pos_x_arr[0];
                    }
                    else{
                        x_move-=conf.pos_x_arr[1];
                    }

                }
                else{
                    x_move+=-conf.pos_x;
                }
                return x_move;
            },
            useDecisionArr:function(){
                if(this.decision_next_arr.length==0){
                    return false;
                }
                var decision=this.decision_next_arr.shift();

                this.pos_start=copyArray(decision.pos_start);
                this.pos_last_end=copyArray(decision.pos_last_end);
                this.decision=decision.decision;
                this.decision_val=decision.decision_val;
                this.step=decision.step;
                this.step_max=decision.step_max;
                this.step_anim=decision.step_anim;
                this.step_anim_type=decision.step_anim_type;

                return true;
            },
            willDefend:function(res){
                if(this.decision!="move"){
                    return false;
                }
                if(this.decision_next_arr.length>0){
                    return false;
                }
//                return false;

                var anim_arr=this.findFieldId(res.pos);
                var anim_id=anim_arr.join("_");
                if(typeof this.defend_conf_one[anim_id]=="undefined"){
                    return false;
                }
                var conf=this.defend_conf_one[anim_id];
                var conf_img=this.imagesConf[conf.img];
                var wait_add=0;
                if(typeof conf.wait!="undefined"){
                    wait_add+=conf.wait;
                }
                //ile trzeba przesunąc
                var x_move=this.countDefendX(res.pos,conf);
                var clip_move=Math.ceil(Math.abs(x_move/this.speed_defense_const));
                var clip_move_org=clip_move;
                var clip_need=conf_img.clips;

                if(conf.move=="during"){
                    clip_need=Math.max(clip_move,clip_need);
                }
                else if(conf.move=="after"){
                    clip_need+=clip_move;
                }
                var clip_need_all=clip_need+wait_add;
//                $.qLog(clip_need_all+"_"+res.step_max+"_"+clip_move_org+ " oooo ");


                if(clip_need>res.step_max){
                    clip_move-=clip_need-res.step_max;
                    x_move=Math.round(x_move*clip_move/clip_move_org);
                }

                var pos_end=copyArray(this.pos);
                pos_end[0]+=x_move;



                if(conf.move=="during"){
                    this.decision_next_arr.push({
                        "pos_start":copyArray(this.pos),
                        "pos_last_end":copyArray(pos_end),
                        "decision":"defend",
                        "decision_val":conf.img,
                        "step":0,
                        "step_max":Math.min(res.step_max,clip_need),
                        "step_anim":-1,
                        "step_anim_type":"min"
                    });

                }
                else if(conf.move=="after"){
                    this.decision_next_arr.push({
                        "pos_start":copyArray(this.pos),
                        "pos_last_end":copyArray(this.pos),
                        "decision":"defend",
                        "decision_val":conf.img,
                        "step":0,
                        "step_max":conf_img.clips,
                        "step_anim":-1,
                        "step_anim_type":""
                    });
                    this.decision_next_arr.push({
                        "pos_start":copyArray(this.pos),
                        "pos_last_end":copyArray(pos_end),
                        "decision":"defend",
                        "decision_val":conf.img,
                        "step":0,
                        "step_max":clip_move,
                        "step_anim":conf_img.clips,
                        "step_anim_type":"min"
                    });
                }
                if(conf.two_side==1){
                    this.decision_next_arr.push({
                        "pos_start":copyArray(pos_end),
                        "pos_last_end":copyArray(pos_end),
                        "decision":"defend",
                        "decision_val":conf.img,
                        "step":0,
                        "step_max":conf_img.clips,
                        "step_anim":-1,
                        "step_anim_type":"back"
                    });
                }

                var i,image_name,qclips;
                if(typeof conf.img_next_arr!="undefined" && conf.img_next_arr.length){
                    for(i in conf.img_next_arr){
                        image_name=conf.img_next_arr[i];
                        qclips=this.imagesConf[image_name].clips;
                        this.decision_next_arr.push({
                            "pos_start":copyArray(pos_end),
                            "pos_last_end":copyArray(pos_end),
                            "decision":"defend",
                            "decision_val":image_name,
                            "step":0,
                            "step_max":qclips,
                            "step_anim":-1,
                            "step_anim_type":""
                        });
                    }
                }



                if(clip_need_all<res.step_max){
                    this.setWait(res.step_max-clip_need_all);
                    this.decision_next_wait=res.step_max-clip_need_all;
                }
                else if(wait_add){
                    this.setWait(wait_add);
                    this.decision_next_wait=wait_add;
                }
                else{
                    this.decision_next_wait=0;
                }



                if(clip_need_all<=res.step_max){
                    return true;
                }
                return false;
            }
        };


        function gateObj(){
            this.left=188;
            this.top=86;
            this.width=865;
            this.height=462;
            this.border_top=15;
            this.border_left=17;
            this.border_right=21;
            this.gate_back=[360,917];
            this.step=0;
            this.step_max=4;
            this.vec_move=[];
            this.pos_net=[0,0];
            this.net_dir=0;
            this.imgConf={
                gate_net:{path:_IMG_SERV+"/gfx/place/soccergame/gate_net.png",pos:[204,100]},
                gate:{path:_IMG_SERV+"/gfx/place/soccergame/gate.png",pos:[185,82]}
            };
            this.imgObj={};
            this.imgState={};
            var i;
            for(i in this.imgConf){
                this.imgObj[i]=new Image();
                this.imgObj[i].src=this.imgConf[i].path;
                this.imgState[i]={
                    pos_init:copyArray(this.imgConf[i].pos),
                    pos:copyArray(this.imgConf[i].pos),
                    move:[0,0]
                };
            }
        }
        gateObj.prototype={
            isInGate:function(pos,size){
                //left

                var treshold=this.takeTreshold(size);
                if(pos[0]>treshold[0][0] && pos[0]<treshold[0][1] && pos[1]>treshold[1][0] && pos[1]<treshold[1][1]){
                    return 1;
                }
                return 0;
            },
            takeTreshold:function(size){
                var treshold=[
                    [this.left+this.border_left+size[0]/2,this.left+this.border_left+this.width-size[0]/2],
                    [this.top+this.border_top+size[1]/2,this.top+this.border_top+this.height-size[1]/2]
                ];
                return treshold;
            },
            move:function(){

                if(this.net_dir<=0){
                    this.pos_net=[0,0];
                }
                else{
                    this.step++;
                    var dir2conf={
                        "5":{part:100,add:-1},
                        "4":{part:60,add:1},
                        "3":{part:60,add:-1},
                        "2":{part:30,add:1},
                        "1":{part:30,add:-1},
                    };
                    var conf=dir2conf[this.net_dir];
                    var part;
                    if(conf.add==-1){
                        part=conf.part*(1-this.step/this.step_max);
                    }
                    else{
                        part=conf.part*(this.step/this.step_max);
                    }
                    this.pos_net[0]=Math.round(this.vec_move[0]*part/100);
                    this.pos_net[1]=Math.round(this.vec_move[1]*part/100);
                    if(this.step>=this.step_max){
                        this.net_dir--;
                        this.step=0;
                    }
                }



            },
            draw:function(ctx){
                var i,bum,pos=[];
                for(i in this.imgState){
                    bum=this.imgState[i];
                    pos=[bum.pos[0],bum.pos[1]];
                    if(i=="gate_net"){
                        pos[0]+=this.pos_net[0];
                        pos[1]+=this.pos_net[1];
                    }
                    ctx.drawImage(this.imgObj[i],pos[0],pos[1]);
                }
            },
            punch:function(pos){
                var pos_init=[Math.round(settings.width/2),settings.height];
                var vec_ball=minusVector(pos,pos_init);
                var y_max=3,x_max;
                x_max=Math.round(y_max*vec_ball[0]/vec_ball[1]);
                this.vec_move=[-x_max,-y_max];
                this.net_dir=5;
                this.step=-1;
//                $.qLog(this.vec_move[0]+"_"+this.vec_move[1]+" ");
            }

        };
        function ballObj(girl){
            this.pos=[];
            this.pos_end=[];
            this.pos_init=[Math.round(settings.width/2),settings.height,1800];

            this.state="wait";

            this.step=-10;
            this.step_anim=0;
            this.step_max=0;

            this.ball_conf={width:100,height:100,clips:3,
                percent_on_gate:70,percent_in_gate:60,
                speed:120
            };
            this.ball_size_cur=100;
            this.img=new Image();
            this.img.src=_IMG_SERV+"/gfx/place/soccergame/girl/ball.png";
            this.gate= new gateObj();
            this.was_defended=0;
            this.was_defended_by="gate";
            this.ball_out=0;
            this.to_delete=0;

            this.vec_distance;
            this.vec_sm;
            this.vec_out_sm;
            this.opacity=100;
            this.vec_gate=[0,0];
            this.vec_gate_out=[];

            this.smBreak=0.7;

            this.girl=girl;

        }
        ballObj.prototype={
            init:function(show_ball_in){
                this.pos=copyArray(this.pos_init);
                this.step=-show_ball_in;
            },
            canKick:function(){
                if(this.step>=0 && this.state=="wait"){
                    return 1;
                }
                return 0;
            },
            draw:function(ctx,z_type){
                if(this.state==""){
                    return false;
                }
                if(z_type=="front" && !in_array(this.state,["move","move_out"])){
                    return false;
                }
                if(z_type=="back" && this.state=="move"){
                    return false;
                }
                if(z_type=="back_out" && this.state!="ball_out"){
                    return false;
                }
                if(z_type!="back_out" && this.state=="ball_out"){
                    return false;
                }
                if(this.state!="wait"){
                    //move
                    drawImageCropCenter(
                        ctx,
                        this.img,
                        this.pos[0],this.pos[1],
                        (0%this.ball_conf.clips)*this.ball_conf.width,0,
                        this.ball_conf.width,this.ball_conf.height,
                        this.ball_size_cur,this.opacity
                    );
//                    $.qLog(this.vec_sm(0)+" "+this.vec_sm(1)+" "+this.vec_sm(2)+"<br>");
//                    var tt;
//                    for(tt=0;tt<=2;tt+=0.1){
//                        drawImage(
//                            ctx,
//                            this.img,
//                            tt*100+100,600+this.vec_sm(tt),
//                            5
//                        );
//                    }
//                    for(tt=0;tt<=3;tt+=0.1){
//                        drawImage(
//                            ctx,
//                            this.img,
//                            tt*100+500,600+this.vec_sm(tt),
//                            5
//                        );
//                    }
//                    for(tt=0;tt<=1;tt+=0.1){
//                        drawImage(
//                            ctx,
//                            this.img,
//                            tt*100+900,600+this.vec_sm(tt),
//                            5
//                        );
//                    }

                }
                else{
                    //wait
                    if(this.step>0){
                        drawImageCropCenter(
                            ctx,
                            this.img,
                            this.pos_init[0],this.pos_init[1],
                            (0%this.ball_conf.clips)*this.ball_conf.width,0,
                            this.ball_conf.width,this.ball_conf.height,
                            100
                        );
                    }
                }
                return true;
            },
            move:function(){
                this.step++;
                var goal=0;
                if(this.state=="move"){
                    if(this.step<=this.step_max){
                        var pos=copyArray(this.pos_init);
                        pos[0]+=this.vec_distance[0]*this.step/this.step_max;
                        pos[1]+=this.vec_distance[1]*this.step/this.step_max;
                        var smIndex=0,smBreak=this.smBreak;
                        if(this.step/this.step_max<smBreak){
                            smIndex=this.step/this.step_max/smBreak;
                        }
                        else{
                            smIndex=1+(this.step/this.step_max-smBreak)/(1-smBreak);
                        }
                        if(this.vec_sm){
                            pos[1]+=this.vec_sm(smIndex);
                        }
                        pos[0]=Math.round(pos[0]);
                        pos[1]=Math.round(pos[1]);
                        this.pos=pos;
                        this.ball_size_cur=100-(100-this.ball_conf.percent_on_gate)*this.step/this.step_max;
                    }
                    else{
                        if(this.girl.isBallHitGirl([this.pos[0],this.pos[1]],Math.round(this.img.height/2*this.ball_size_cur/100))){
                            this.was_defended=1;
                            this.was_defended_by="girl";
                        }


                        if(this.was_defended){
                            this.setMoveOut();
                            goal=-1;
                        }
                        else if(this.ball_out){
                            this.state="ball_out";
                            this.pos_end=copyArray(this.pos);
                            this.step_max=this.step_gate;
                            goal=-1;
                        }
                        else{
                            _mySound.playSound("soccer_net");
                            this.state="gate";
                            this.step_max=this.step_gate;
                            goal=1;
                            //goal !!!!
                        }
                        this.step=0;
                    }
                }
                if(this.state=="move_out"){
//                    vec_gate_out
//                    this.pos
                    var pos=copyArray(this.pos_init);
                    pos[0]+=Math.round(this.vec_gate_out[0]*this.step/this.step_max);
                    pos[1]+=Math.round(this.vec_gate_out[1]*this.step/this.step_max);
                    this.pos=copyArray(pos);
                    this.ball_size_cur=Math.round(this.ball_conf.percent_on_gate+(100-this.ball_conf.percent_on_gate)*this.vec_gate_out[2]/500*this.step/this.step_max);
//                    var ball_size=this.ball_conf.percent_on_gate;
//                    this.ball_conf.percent_in_gate;
                    if(this.step>this.step_max){
                        this.to_delete=1;
                    }
                }
                if(this.state=="gate"){
                    var pos=copyArray(this.pos_init);
                    pos[0]+=this.vec_distance[0];
                    pos[1]+=this.vec_distance[1];
                    if(this.vec_sm){
                        pos[1]+=Math.round(this.vec_sm(2+Math.min(this.step/this.step_max,1)));
                    }
                    pos[0]+=Math.round(this.vec_gate[0]*Math.min(this.step/this.step_max,1));
                    pos[1]+=Math.round(this.vec_gate[1]*Math.min(this.step/this.step_max,1));
                    this.pos=pos;
                    var opacity_step_max=30;
                    var ball_size=this.ball_conf.percent_on_gate;
                    ball_size-=(this.ball_conf.percent_on_gate-this.ball_conf.percent_in_gate)*this.step/this.step_max;
                    ball_size=Math.max(ball_size,this.ball_conf.percent_in_gate)
                    if(this.step>this.step_max){
                        var opacity=Math.round(100-(this.step-this.step_max)/opacity_step_max*100);
                        if(opacity<0){
                            opacity=0;
                            this.to_delete=1;
                        }
                    }
                    else{

                    }
                    this.ball_size_cur=ball_size;
                    this.opacity=opacity;
                }
                if(this.state=="ball_out"){
                    var pos=copyArray(this.pos_end);
                    var step_part=Math.min(1,this.step/this.step_max);
                    pos[0]+=this.vec_gate[0]*step_part;
                    pos[1]+=this.vec_gate[1]*step_part;
                    if(this.vec_sm){
                        pos[1]-=this.vec_sm(2)-this.vec_sm(2+step_part);
                    }
                    this.pos=pos;
                    this.ball_size_cur=this.ball_conf.percent_on_gate*(1-0.3*step_part);
                    var opacity=100;
                    if(this.step>this.step_max){
                        var opacity_step_max=40;
                        opacity=Math.round(100-(this.step-this.step_max)/opacity_step_max*100);
                        if(opacity<0){
                            opacity=0;
                            this.to_delete=1;
                        }
                    }
                    this.opacity=opacity;
                }
                var res={to_delete:this.to_delete,pos:copyArray(this.pos),goal:goal,
                    ball_radius:Math.round(this.ball_conf.height/2*this.ball_size_cur/100),
                    can_kick:this.canKick()
                };

                return res;
            },
            setMoveOut:function(type){
                var x_range,y_range=[10,300],z_range=[200,500];
                if(this.pos[0]<settings.width/2){
                    x_range=[-1200,-700];
                }
                else{
                    x_range=[700,1200];
                }
                if(type){
                    this.was_defended_by=type;
                    this.was_defended=1;
                }

                if(this.was_defended_by=="gate"){
//                    $.qLog(this.pos[1]+"_"+(this.gate.top+this.gate.border_top))
                    if(this.pos[1]<this.gate.top+this.gate.border_top){
                        if(this.pos[0]<settings.width/2){
                            x_range=[-100,-10];
                        }
                        else{
                            x_range=[10,100];
                        }
                        y_range=[-300,-200];
                    }
                    _mySound.playSound("soccer_gate");
                }
                if(this.was_defended_by=="girl"){
                    _mySound.playSound("soccer_defend");
                }
                this.vec_gate_out=[
                    mt_rand(x_range[0],x_range[1]),
                    mt_rand(y_range[0],y_range[1]),
                    mt_rand(z_range[0],z_range[1])
                ];
                var distance=Math.sqrt(
                    this.vec_gate_out[0]*this.vec_gate_out[0]+
                    this.vec_gate_out[1]*this.vec_gate_out[1]
//                    +this.vec_gate_out[2]*this.vec_gate_out[2]
                );

                this.step=-1;
                this.step_max=Math.ceil(distance/30);
                this.state="move_out";
                this.pos_init=copyArray(this.pos);

            },
            girlWillDefend:function(pos_end){
                this.was_defended=1;
                this.was_defended_by="girl";
            },

            kick:function(cursor_pos){


                this.step=0;

                var ball_size_on_gate=Math.round(this.ball_conf.height*this.ball_conf.percent_on_gate/100);
                var gate_depth=35;
                var gate_bottom=this.gate.takeTreshold([0,0])[1][1]-gate_depth-Math.round(ball_size_on_gate/2);
                var vec_distance=minusVector([cursor_pos[0],gate_bottom],this.pos_init);
                var height_more=cursor_pos[1]-gate_bottom;
                var height_best=Math.round(height_more*1.2);

                var height_gate=0;
                this.vec_sm= new Smooth([0,height_best,height_more,height_gate]);

//                $.qLog(" "+height_more+" ");
                var vec3_end=[cursor_pos[0],cursor_pos[1],0];
                var vec3_move=[
                    vec3_end[0]-this.pos_init[0],
                    vec3_end[1]-this.pos_init[1],
                    vec3_end[2]-this.pos_init[2]
                ];
                var vec3_move_length=Math.sqrt(
                    vec3_move[0]*vec3_move[0]+
                    vec3_move[1]*vec3_move[1]+
                    vec3_move[2]*vec3_move[2]
                );
                this.step_max=Math.ceil(vec3_move_length/this.ball_conf.speed);
                this.ball_size_cur=100;

                if(this.gate.isInGate(cursor_pos,[
                        -this.gate.border_left-ball_size_on_gate,
                        -this.gate.border_top-ball_size_on_gate
                    ])){
                    this.was_defended=1;
                    if(this.gate.isInGate(cursor_pos,[0,0])){
                        this.was_defended=0;
                    }


                    this.vec_gate=[0,0];
                    if(cursor_pos[0]<this.gate.gate_back[0]){
                        this.vec_gate=[this.gate.gate_back[0]-cursor_pos[0],0];
                    }
                    if(cursor_pos[0]>this.gate.gate_back[1]){
                        this.vec_gate=[this.gate.gate_back[1]-cursor_pos[0],0];
                    }


                    if(height_more>=0 && cursor_pos[0]>this.gate.gate_back[0] && cursor_pos[0]<this.gate.gate_back[1]){
                        //ground only
                        vec_distance=minusVector([cursor_pos[0], cursor_pos[1]],this.pos_init);
//                        this.step_max=Math.ceil(lengthVector(vec_distance)/this.ball_conf.speed);
                        this.vec_sm=false;
                        var speed_on_step=lengthVector(vec_distance)/this.step_max;

                        this.vec_gate=[-vec_distance[0]*height_more/vec_distance[1],-height_more];
//                        console.log(this.vec_gate);
                        var tmp=lengthVector(this.vec_gate);

                        this.step_gate=Math.floor(tmp/speed_on_step);
                        this.vec_gate=scaleVector(this.vec_gate,tmp*speed_on_step/(tmp/this.step_gate),tmp);
                        this.step=1;
                    }
                    else{
                        var tmp_dis=(height_more-height_gate)*(height_more-height_gate)+this.vec_gate[0]*this.vec_gate[0]+
                            this.vec_gate[1]*this.vec_gate[1];
                        this.step_gate=Math.ceil(Math.sqrt(tmp_dis)/(this.ball_conf.speed*0.3));
                    }
                    this.vec_distance=copyArray(vec_distance);

                    this.state="move";


                }
                else{
                    this.ball_out=1;

                    this.vec_sm= new Smooth([0,height_best,height_more,height_gate+30]);
                    if(height_more>=0){
                        //ground only
                        vec_distance=minusVector([cursor_pos[0], cursor_pos[1]],this.pos_init);
                        this.vec_sm=false;
                        this.step=1;
                    }
                    else{

                    }
                    this.vec_distance=copyArray(vec_distance);


                    this.step_gate=Math.round(this.step_max*(1-this.smBreak));
                    var q_vec=[this.vec_distance[0],this.vec_distance[1]];
                    var vec_dis_length=lengthVector(q_vec);
                    this.vec_gate=scaleVector(this.vec_distance,vec_dis_length*this.step_gate/this.step_max,vec_dis_length);
//                    this.vec_gate[1]=-this.vec_gate[1];
                    this.state="move";

                    //poza
                }






                return {step_max:this.step_max,pos:cursor_pos};
            },
            takeBallSize:function(){
                var size=Math.round(this.ball_conf.height*this.ball_conf.percent_on_gate/100);
                return size;
            }
        };

        function cursorObj(posEnd,gate){
            this.step=0;
            this.step_max=0;
            this.pos=[0,0];

            this.pos_start=[0,0];
            this.vec_move=[0,0];
            this.pos_end=posEnd;
            this.pos_last_end=[-1,-1];
            this.active=1;

            this.img;
            this.speed_const=settings.cursor_speed;//90;

            this.img=new Image();
            this.img.src=_IMG_SERV+"/gfx/place/soccergame/test/circle_min.png?2";
            this.radius=35;
            this.gate=gate;
        }
        cursorObj.prototype={
            findNewEnd:function(){
                this.pos_last_end=copyArray(this.pos_end);
                this.pos_start=copyArray(this.pos);
                this.step=0;
                var distance=lengthVector(minusVector(this.pos_last_end,this.pos));
                this.step_max=Math.ceil(distance/this.speed_const);
            },
            takePos:function(){
                return copyArray(this.pos);
            },
            setActive:function(active_in){
                this.active=-active_in+1;
            },
            move:function(){
                if(this.pos_end[0]!=this.pos_last_end[0] || this.pos_end[1]!=this.pos_last_end[1]){
                    this.findNewEnd();
                }
                this.step++;
                this.active++;
                var vec_move=minusVector(this.pos_last_end,this.pos_start);
                if(this.step<=this.step_max){
                    var pos=addVectorToPoint(this.pos_start,[
                        Math.round(vec_move[0]*this.step/this.step_max),
                        Math.round(vec_move[1]*this.step/this.step_max)
                    ]);
                    var treshold=this.gate.takeTreshold([this.radius*2,this.radius*2])
                    pos[1]=Math.min(pos[1],treshold[1][1]);
//                    pos[1]=Math.max(pos[1],treshold[1][0]);
//                    pos[0]=Math.max(pos[0],treshold[0][0]);
//                    pos[0]=Math.min(pos[0],treshold[0][1]);
                    this.pos=pos;
                }
            },
            draw:function(ctx){
                var cur_clip=0;
                if(this.active>0){
                    cur_clip=1;
                }
                drawImageCropCenter(
                    ctx,
                    this.img,
                    this.pos[0],this.pos[1],
                    cur_clip*(96),0,
                    (96),(96)
                );


            }
        };
        function textObj(text,pos,stroke_color){
            this.text=text;
            this.pos=copyArray(pos);
            this.stroke_color=stroke_color;
            this.step=0;
            this.step_max=15;
            this.opacity=100;
            this.text_size=[];
        }
        textObj.prototype={
            move:function(){
                this.step++;
                var opacity_max=30;
                if(this.step>this.step_max){
                    this.opacity=Math.round(100-100*(this.step-this.step_max)/opacity_max);
                    this.opacity=Math.max(0,this.opacity);
                }
                var res={to_delete:0};
                if(this.opacity==0){
                    res.to_delete=1;
                }
                return res;
            },
            draw:function(ctx){
                if(typeof this.text_size[0]=="undefined"){
                    this.text_size=getTextSize(ctx,this.text,"Montserrat",32);
                }

                drawText(ctx,this.text,this.pos,32,"Montserrat","white",this.stroke_color,3,this.opacity,this.text_size);
            }
        };
        function targetObj(type,pos,targetConf){
            this.pos=copyArray(pos);
            this.step=0;
            this.step2=0;
            this.type=type;
            this.targetConf={
                "good":{path:_IMG_SERV+"/gfx/place/soccergame/target/good.png",step_expire:300},
                "bomb":{path:_IMG_SERV+"/gfx/place/soccergame/target/bomb.png",step_expire:300},
                "target":{clips:2,width:100,height:100,path:_IMG_SERV+"/gfx/place/soccergame/target/target_all.png",step_expire:-1},
                "explosion":{clips:6,width:250,height:250,path:_IMG_SERV+"/gfx/place/soccergame/target/explosion.png?2",step_expire:-1,can_hit:0},
                "good_hit":{clips:18,width:121,height:118,path:_IMG_SERV+"/gfx/place/soccergame/target/good_hit.png",step_expire:-1},
                "target_hit":{clips:18,width:124,height:122,path:_IMG_SERV+"/gfx/place/soccergame/target/target_hit.png",step_expire:-1},

                "target_premium":{path:_IMG_SERV+"/gfx/place/soccergame/target/target_premium.png",step_expire:300},
                "target_premium_hit":{clips:15,width:114,height:111,path:_IMG_SERV+"/gfx/place/soccergame/target/target_premium_hit.png",step_expire:-1},
                "target_change":{path:_IMG_SERV+"/gfx/place/soccergame/target/target_change.png",step_expire:300},
                "target_change_hit":{clips:14,width:122,height:117,path:_IMG_SERV+"/gfx/place/soccergame/target/target_change_hit.png",step_expire:-1},

            };
            targetConf=$.extend({
                explosion_on_step:-1
            },targetConf);
            var conf_main=$.extend({
                clips:0,
                can_hit:1,
                anim_period:-1
            },this.targetConf[type]);
            this.conf=$.extend(conf_main,targetConf);
            this.step_expire=this.conf.step_expire;
            this.step_explosion=this.conf.explosion_on_step;
            this.img=new Image();
            this.img.src=this.conf.path;
            this.radius=Math.round(this.img.height/2);
            this.to_delete=0;
            this.opacity=100;
            this.step_anim=0;
            this.anim_period=this.conf.anim_period;
            this.step_explosion_fast=50;
            this.was_hit=0;

            this.cur_size=100;
        }

        targetObj.prototype={
            init:function(){
                this.initByType();
            },
            initByType:function(){
                if(this.type=="target"){
                    var step_explosion=this.step_explosion-this.step_explosion_fast;
                    this.anim_period=Math.ceil((-1+Math.sqrt(1+8*step_explosion))/2);

                    var d=Math.ceil((this.anim_period+1)*this.anim_period/2);
                    this.step2=d-step_explosion;
                    this.anim_period++;
                }
            },
            move:function(){
                this.step++;
                this.step2++;
                this.step_anim++;
                if(this.anim_period>0){
                    this.step_anim=this.step2%this.anim_period;
                }

                var explosion=0;
                if(this.step_expire!=-1){
                    if(this.step>this.step_expire){
                        var opacity_step=30;
                        this.opacity=Math.max(0,100-100*(this.step-this.step_expire)/opacity_step);
                        if(this.opacity==0){
                            this.to_delete=1;
                        }
                    }
                }
                if(this.step_explosion!=-1){
                    if(this.step>this.step_explosion){
                        explosion=1;
                        this.makeExplosion();
                    }
                }
                if(this.type=="explosion"){
                    this.step_anim=this.step;
                    if(this.step>this.conf.clips){
                        this.to_delete=1;
                    }
                }
                if(this.type=="target"){
                    if(this.step_explosion-this.step<this.step_explosion_fast){
                        this.step_anim=this.step%2;
                    }
                    else{
                        this.step_anim=this.anim_period%2;
                    }
                    if(this.step2+1>=this.anim_period){
                        this.step2=0;
                        this.anim_period=Math.max(2,this.anim_period-1);
                    }

                }
                var res={to_delete:this.to_delete,explosion:explosion,pos:this.pos};
                return res;
            },
            draw:function(ctx){
                if(this.conf.clips==0){
                    drawImage(ctx,this.img,this.pos[0],this.pos[1],100,this.opacity);
                }
                else{
                    var step_anim=this.step_anim;
                    step_anim=Math.min(this.step_anim,this.conf.clips);
                    drawImageCropCenter(
                        ctx,this.img,
                        this.pos[0],this.pos[1],
                        step_anim*this.conf.width,0,
                        this.conf.width,this.conf.height,this.cur_size,
                        this.opacity
                    );
                }
            },
            isHit:function(ball_pos,ball_radius){
                if(this.conf.can_hit==0){
                    return 0;
                }
                if(this.was_hit){
                    return 0;
                }
                if(isBallCollision(ball_pos,ball_radius,this.pos,this.img.height/2)){
                    return 1;
                }
                return 0;
            },
            makeExplosion:function(){
                this.conf=$.extend(this.conf,this.targetConf["explosion"]);
                this.img=new Image();
                this.img.src=this.conf.path;
                this.step=-1;
                this.type="explosion";
                this.step_explosion=-1;
                this.cur_size=100;
                this.was_hit=1;
                _mySound.playSound("game_lose");
            },
            makeHit:function(ball_pos,ball_radius){
                var res={was_hit:0,type:"",pos:this.pos};
                if(this.isHit(ball_pos,ball_radius)){
                    this.was_hit=1;
                    this.step_expire=this.step;
                    res.was_hit=1;
                    res.type=this.type;
                    if(this.type=="bomb"){
                        this.makeExplosion();
                    }
                    else if(typeof this.targetConf[this.type+"_hit"]!="undefined"){
                        this.type=this.type+"_hit";
                        this.conf=$.extend(this.conf,this.targetConf[this.type]);
                        this.img=new Image();
                        this.img.src=this.conf.path;
                        this.step=0;
                        this.step_expire=this.conf.clips+1;
                        this.step_anim=0;
                        this.anim_period=0;
                    }

                }
                return res;
            },
            magicChange:function(){
                if(this.conf.can_hit==0 || this.type=="target_premium" || this.was_hit){
                    return false;
                }
                this.step=0;
                this.step2=0;
                this.type="good";
                var conf_main=$.extend({
                    clips:0,
                    can_hit:1,
                    anim_period:-1
                },this.targetConf[this.type]);
                this.conf=conf_main;
                this.step_expire=this.conf.step_expire;
                this.step_explosion=-1;
                this.img=new Image();
                this.img.src=this.conf.path;
                this.radius=Math.round(this.img.height/2);
                this.step_anim=0;
                this.opacity=100;
                this.anim_period=this.conf.anim_period;
                this.cur_size=100;
                return true;
            },
            magicTouch:function(){
                var res={was_hit:0,type:"",pos:this.pos};
                if(this.conf.can_hit==0){
                    return res;
                }
                if(this.was_hit){
                    return res;
                }
                this.was_hit=1;
                this.step_expire=this.step;

                if(this.type=="bomb"){

                }
                else if(typeof this.targetConf[this.type+"_hit"]!="undefined"){
                    res.was_hit=1;
                    res.type=this.type;

                    this.type=this.type+"_hit";
                    this.conf=$.extend(this.conf,this.targetConf[this.type]);
                    this.img=new Image();
                    this.img.src=this.conf.path;
                    this.step=0;
                    this.step_expire=this.conf.clips+1;
                    this.step_anim=0;
                    this.anim_period=0;
                }

                return res;
            }

        };

        function animObj(cursorPos,level,hard,hard_max){

            hard=Math.min(hard,hard_max);

            this.step=0;
            this.gate=new gateObj();
            this.cursor=new cursorObj(cursorPos,this.gate);
            this.girl=new girlObj(cursorPos,hard,hard_max);
            this.ball_arr=[];
            this.target_arr=[];
            this.event_arr=[];
            this.text_arr=[];

            this.kick_last_pos=[];
            this.level=level;
            this.level_conf={
                "0":{
                    target_step_add:[90,45],
                    type_arr:{good:40,bomb:30,target:30,good_arr:0},
                    target_count_max:[2,2],
                    target_conf:{
                        target:{explosion_on_step:700}
                    }
                },
                "1":{
                    target_step_add:[90,45],
                    type_arr:{good:40,bomb:30,target:30,good_arr:0},
                    target_count_max:[2,2],
                    target_conf:{
                        target:{explosion_on_step:700}
                    }
                },
                "2":{
                    target_step_add:[90,45],
                    type_arr:{good:40,bomb:30,target:30,good_arr:0},
                    target_count_max:[2,2],
                    target_conf:{
                        target:{explosion_on_step:700}
                    }
                },
                "3":{
                    target_step_add:[85,45],
                    type_arr:{good:40,bomb:30,target:30,good_arr:0},
                    target_count_max:[3,3],
                    target_conf:{
                        target:{explosion_on_step:700}
                    }
                },
                "4":{
                    target_step_add:[80,45],
                    type_arr:{good:40,bomb:30,target:30,good_arr:0},
                    target_count_max:[3,3],
                    target_conf:{
                        target:{explosion_on_step:700}
                    }
                },
                "5":{
                    target_step_add:[75,40],
                    type_arr:{good:35,bomb:35,target:30,good_arr:0},
                    target_count_max:[3,4],
                    target_conf:{
                        target:{explosion_on_step:650}
                    }
                },
                "6":{
                    target_step_add:[70,40],
                    type_arr:{good:30,bomb:30,target:40,good_arr:0},
                    target_count_max:[3,4],
                    target_conf:{
                        target:{explosion_on_step:600}
                    }
                },
                "7":{
                    target_step_add:[65,35],
                    type_arr:{good:30,bomb:30,target:40,good_arr:0},
                    target_count_max:[3,4],
                    target_conf:{
                        target:{explosion_on_step:600}
                    }
                },
                "8":{
                    target_step_add:[60,35],
                    type_arr:{good:30,bomb:30,target:40,good_arr:0},
                    target_count_max:[4,5],
                    target_conf:{
                        target:{explosion_on_step:550}
                    }
                },
                "9":{
                    target_step_add:[60,30],
                    type_arr:{good:20,bomb:30,target:50,good_arr:0},
                    target_count_max:[4,6],
                    target_conf:{
                        target:{explosion_on_step:550}
                    }
                },
                "10":{
                    target_step_add:[55,30],
                    type_arr:{good:15,bomb:30,target:55,good_arr:0},
                    target_count_max:[5,7],
                    target_conf:{
                        target:{explosion_on_step:500}
                    }
                },
                "11":{
                    target_step_add:[50,20],
                    type_arr:{good:10,bomb:25,target:65,good_arr:0},
                    target_count_max:[5,8],
                    target_conf:{
                        target:{explosion_on_step:450}
                    }
                }
            };

            this.hard=hard;
            this.hard_max=hard_max;


            this.conf=this.level_conf[level];


            this.conf.target_step_add=Math.ceil(
                this.conf.target_step_add[0]-(this.conf.target_step_add[0]-this.conf.target_step_add[1])*hard/hard_max
            );
            this.conf.target_count_max=Math.round(
                this.conf.target_count_max[0]-(this.conf.target_count_max[0]-this.conf.target_count_max[1])*hard/hard_max
            );

            var add_percent=60*(this.hard_max-this.hard)/this.hard_max;
            this.conf.target_conf.target.explosion_on_step=Math.round(
                this.conf.target_conf.target.explosion_on_step*(100+add_percent)/100
            );

        }
        animObj.prototype={
            init:function(){
                this.ball_arr.push(new ballObj(this.girl));
                this.ball_arr[0].init(0);
                this.girl.init(this.ball_arr[0].takeBallSize());

            },
            takeConf:function(){
                return this.conf;
            },
            setExplosionLevel:function(){


            },
            start:function(){
                drawScene();
            },
            kick:function(){
                var ball_kick=this.ball_arr[this.ball_arr.length-1];
                if(!ball_kick.canKick()){
                    return false;
                }
                if(settings.isMobile){
                    this.cursor.move();
                }
                this.kick_last_pos=this.cursor.takePos();



                var res=ball_kick.kick(copyArray(this.kick_last_pos));

                if(this.girl.willDefend(res)){
                    ball_kick.girlWillDefend(res.pos);
                }

                var ball_new=new ballObj(this.girl);
                var nextBall=Math.floor(res.step_max*8/9);
                ball_new.init(nextBall);
                this.ball_arr.push(ball_new);
                this.cursor.setActive(nextBall);
                _mySound.playSound("soccer_shot");
                return true;
            },
            takeEventArr:function(){
                var res=[];
                if(this.event_arr.length==0){
                    return res;
                }
                res=copyArray(this.event_arr);
                this.event_arr=[];
                return res;
            },
            takePreriod:function(){
                return this.period;
            },
            tryAddTargetPremium:function(){
                var chance=10,rand=mt_rand(1,100),type="";
                if(rand<=chance){
                    type="target_premium";
                }
                else if(rand<=chance*2){
                    type="target_change";
                }
                if(type=="" || settings[type]==0){
                    return "";
                }
                var i;
                for(i in this.target_arr){
                    if(this.target_arr[i].type==type){
                        return "";
                    }
                }
                return type;
            },
            tryAddTarget:function(){
                if(this.target_arr.length>=this.conf.target_count_max){
                    return false;
                }
                var i,res;
                var val_random=mt_rand(1,100),type,cur=0;

                for(i=0;i<5;i++){
                    cur=0;
                    type=this.tryAddTargetPremium();

                    if(type==""){
                        for(type in this.conf.type_arr){

                            cur+=this.conf.type_arr[type];
                            if(cur>=val_random){
                                break;
                            }
                        }
                    }
                    res=this.tryAddTargetOne(type);
                    if(res.succ){
                        break;
                    }
                }
                if(res.succ==0){
                    return false;
                }

                var targetConf={};
                if(typeof this.conf.target_conf[type]!="undefined"){
                    targetConf=$.extend(targetConf, this.conf.target_conf[type])
                }


                var targetNew= new targetObj(type,res.pos,targetConf);
                targetNew.init();
                this.target_arr.push(targetNew);
                return true;
            },
            checkTargetCollision:function(pos){
                if(isBallCollision(pos,50,this.cursor.takePos(),this.cursor.radius)){
                    return false;
                }
                if(isBallCollision(pos,50,this.kick_last_pos,50)){
                    return false;
                }
                var i;
                for(i in this.target_arr){
                    if(this.target_arr[i].isHit(pos,50)){
                        return false;
                    }
                }
                return true;
            },
            tryAddTargetOne:function(type){
                var res={succ:0};
                var treshold=this.gate.takeTreshold([100,100]);
                var pos=[],i;

                if(settings.level>-1 && type=="bomb"){
                    for(i=0;i<4 || pos.length==0;i++){
                        if(mt_rand(1,100)>50){
                            pos[0]=mt_rand(treshold[0][0]+10,treshold[0][0]+100);
                        }
                        else{
                            pos[0]=mt_rand(treshold[0][1]-100,treshold[0][1]-10);
                        }
                        pos[1]=mt_rand(treshold[1][0]+10,treshold[1][1]-30);
                        pos[1]=mt_rand(treshold[1][0]+10,pos[1]);
                        if(!this.checkTargetCollision(pos)){
                            pos=[];
                        }
                    }
                }
                if(typeof pos[0]=="undefined"){
                    pos[0]=mt_rand(treshold[0][0]+10,treshold[0][1]-10);

                    if(this.hard/this.hard_max<0.3){
                        if(pos[0]>treshold[0][1]/2){
                            pos[0]=mt_rand(pos[0],treshold[0][1]-10);
                        }
                        else{
                            pos[0]=mt_rand(treshold[0][0]+10,pos[0]);
                        }
                    }

                    pos[1]=mt_rand(treshold[1][0]+10,treshold[1][1]-30);
                }

                if(!this.checkTargetCollision(pos)){
                    return res;
                }

                res.succ=1;
                res.pos=pos;
                return res;
            },
            addText:function(text,pos,stroke_color){
                var text_obj=new textObj(text,pos,stroke_color);
                this.text_arr.push(text_obj);
            },
            draw:function(ctx){

                var i,t,qres,hit_res,qevent;


                this.step++;
//
//
                if(this.step>12 && this.step%this.conf.target_step_add==0){
                    this.tryAddTarget();
                }
                this.cursor.move();
                this.girl.move();
                for(i=this.text_arr.length-1;i>=0;i--){
                    qres=this.text_arr[i].move();
                    if(qres.to_delete){
                        this.text_arr.splice(i,1);
                    }
                }
//                $.qLog(" p"+this.text_arr.length+"p ");

                for(i=this.target_arr.length-1;i>=0;i--){
                    qres=this.target_arr[i].move();
                    if(qres.explosion){
                        qevent={succ:0,fail:0,target_type_arr:[]};
                        qevent.target_type_arr.push({type:"explosion",pos:qres.pos});
                        qevent.fail=1;
                        this.event_arr.push(qevent);
                    }
                    if(qres.to_delete){
                        this.target_arr.splice(i,1);
                    }
                }

                for(i=this.ball_arr.length-1;i>=0;i--){
                    qres=this.ball_arr[i].move();
                    if(qres.to_delete){
                        this.ball_arr.splice(i,1);
                    }
                    if(qres.goal!=0){
                        qevent={succ:0,fail:0,target_type_arr:[],ball_pos:[qres.pos[0],qres.pos[1]]};
                        if(qres.goal==1){

                            var was_target_premium=0,was_target_change=0;
                            for(t in this.target_arr){
                                hit_res=this.target_arr[t].makeHit(qres.pos,qres.ball_radius);
                                if(hit_res.was_hit){
                                    if(hit_res.type=="good"){

                                    }
                                    if(hit_res.type=="target_premium"){
                                        was_target_premium=1;
                                    }
                                    if(hit_res.type=="target_change"){
                                        was_target_change=1;
                                    }
                                    if(hit_res.type=="bomb"){
                                        this.ball_arr[i].setMoveOut("bomb");
                                        qres.goal=-1;
                                    }
                                    else{
                                        _mySound.playSound("soccer_target");
                                    }
                                    qevent.target_type_arr.push({type:hit_res.type,pos:hit_res.pos});
                                }
                            }
                            if(was_target_change){
                                for(t in this.target_arr){
                                    this.target_arr[t].magicChange();
                                }
                            }
                            if(was_target_premium){
                                for(t in this.target_arr){
                                    hit_res=this.target_arr[t].magicTouch();
                                    if(hit_res.type){
                                        qevent.target_type_arr.push({type:hit_res.type,pos:hit_res.pos});
                                    }
                                }
                            }

                        }
                        if(qres.goal==1){
                            qevent.succ++;
                        }
                        if(qres.goal==-1){
                            qevent.fail++;
                        }
                        if(qevent.fail==0){
                            this.gate.punch(copyArray(qevent.ball_pos));
                        }
                        this.event_arr.push(qevent);
                    }

                }
                this.gate.move();

//                 var tt=new Date().getTime();
                ctx.clearRect(0, 0, settings.width, settings.height);


                for(i in this.ball_arr){
                    this.ball_arr[i].draw(ctx,"back_out");
                }
                this.gate.draw(ctx);
                for(i in this.ball_arr){
                    this.ball_arr[i].draw(ctx,"back");
                }

                for(i in this.target_arr){
                    this.target_arr[i].draw(ctx);
                }
                this.cursor.draw(ctx);
                this.girl.draw(ctx);
                for(i in this.ball_arr){
                    this.ball_arr[i].draw(ctx,"front");
                }

                for(i=this.text_arr.length-1;i>=0;i--){
                    this.text_arr[i].draw(ctx);
//                    $.qLog(" i ");
                }
//                $.qLog(((new Date().getTime())-tt)+" ");
                if(this.event_arr.length){
                    th.trigger("newEvent");
                }

            },
            stopView:function(ctx){
                this.draw(ctx);
            }
        };


        if(!settings){
            if(typeof options!="object"){
                return false;
            }

            settings=$.extend( {
                width:1280,//{path:"gfx/place/fight/animation/cherry/1/anim.png",}
                height:780,
                period:30,
                level:1,
                cursor_speed:90,
                isMobile:0,
                hard:0,
                hard_max:15,
                target_premium:0,
                target_change:0
            }, options);


            th.attr({width:settings.width,height:settings.height});

            function getNewAnimIndex(){
                var i=getNewObjectIndex(_animIndex,{});
                _animIndex[i]={handler:timeHandler.getNewIndex()};
                _animStorage[i]={"obj_anim":{},cur_anim:""};

                //
                return i;
            }
            function initAnim(animIndex,cursorArr){
                _animStorage[animIndex].obj_anim=new animObj(cursorArr,settings.level,settings.hard,settings.hard_max);
                _animStorage[animIndex].obj_anim.init();

            }
            if(typeof timeHandler=="undefined" || typeof timeHandler.getNewIndex=="undefined"){
                return false;//was not init
            }
            animIndex=getNewAnimIndex();

            var animIndexArr=_animIndex[animIndex];

            settings.animIndex=animIndex;
            var ctx=th[0];
            ctx=ctx.getContext("2d");

            function preparePreloadArr(){
                var arr=[
                    _IMG_SERV+"/gfx/place/soccergame/test/circle_min.png?2",
                    _IMG_SERV+"/gfx/place/soccergame/girl/ball.png",
                    _IMG_SERV+"/gfx/place/soccergame/target/good.png",
                    _IMG_SERV+"/gfx/place/soccergame/target/bomb.png",
                    _IMG_SERV+"/gfx/place/soccergame/target/target_all.png",
                    _IMG_SERV+"/gfx/place/soccergame/target/explosion.png?2",
                    _IMG_SERV+"/gfx/place/soccergame/target/good_hit.png",
                    _IMG_SERV+"/gfx/place/soccergame/target/target_hit.png",
                    _IMG_SERV+"/gfx/place/soccergame/target/target_premium.png",
                    _IMG_SERV+"/gfx/place/soccergame/target/target_premium_hit.png",
                    _IMG_SERV+"/gfx/place/soccergame/target/target_change.png",
                    _IMG_SERV+"/gfx/place/soccergame/target/target_change_hit.png",

                    _IMG_SERV+"/gfx/place/soccergame/gate.png",
                    _IMG_SERV+"/gfx/place/soccergame/gate_net.png",


                    _IMG_SERV+"/gfx/place/soccergame/girl/move/right.png",
                    _IMG_SERV+"/gfx/place/soccergame/girl/move/left.png",
                    _IMG_SERV+"/gfx/place/soccergame/girl/move/wait.png?2",

//                    "/gfx/mis.png",

                    _IMG_SERV+"/gfx/place/soccergame/girl/defend/down.png",
                    _IMG_SERV+"/gfx/place/soccergame/girl/defend/down_back.png",
                    _IMG_SERV+"/gfx/place/soccergame/girl/defend/jump.png",
                    _IMG_SERV+"/gfx/place/soccergame/girl/defend/jump_back.png",
                    _IMG_SERV+"/gfx/place/soccergame/girl/defend/jump_up.png",
                    _IMG_SERV+"/gfx/place/soccergame/girl/defend/left_down.png",
                    _IMG_SERV+"/gfx/place/soccergame/girl/defend/left_down_back.png",
                    _IMG_SERV+"/gfx/place/soccergame/girl/defend/left_down_hand.png",
                    _IMG_SERV+"/gfx/place/soccergame/girl/defend/left_down_hand_back.png",
                    _IMG_SERV+"/gfx/place/soccergame/girl/defend/left_up.png",
                    _IMG_SERV+"/gfx/place/soccergame/girl/defend/left_up_fall.png",
                    _IMG_SERV+"/gfx/place/soccergame/girl/defend/left_up_up.png",
                    _IMG_SERV+"/gfx/place/soccergame/girl/defend/middle_left.png",
                    _IMG_SERV+"/gfx/place/soccergame/girl/defend/middle_left_up.png",
                    _IMG_SERV+"/gfx/place/soccergame/girl/defend/middle_right.png",
                    _IMG_SERV+"/gfx/place/soccergame/girl/defend/middle_right_up.png",
                    _IMG_SERV+"/gfx/place/soccergame/girl/defend/middle_up.png?2",
                    _IMG_SERV+"/gfx/place/soccergame/girl/defend/right_down.png",
                    _IMG_SERV+"/gfx/place/soccergame/girl/defend/right_down_back.png",
                    _IMG_SERV+"/gfx/place/soccergame/girl/defend/right_down_hand.png",
                    _IMG_SERV+"/gfx/place/soccergame/girl/defend/right_down_hand_back.png",
                    _IMG_SERV+"/gfx/place/soccergame/girl/defend/right_up.png",
                    _IMG_SERV+"/gfx/place/soccergame/girl/defend/right_up_fall.png",
                    _IMG_SERV+"/gfx/place/soccergame/girl/defend/right_up_up.png"



                ];

                return arr;
            }


            $("<div/>").one("myload",function(){
                initAnim(animIndex,cursorArr);

                _animStorage[animIndex].obj_anim.stopView(ctx);

                th.data("soccerGame",settings);
                th.trigger("was_loaded");
            }).myLoad(preparePreloadArr());




        }
        else{
            var arg =Array.prototype.slice.call(arguments,1);
            animIndex=settings.animIndex;
            if(methods[options]){
                return methods[options].apply(this,arg);
            }

        }

        return true;

    };
});